import React, { Fragment } from "react";

import Footer from "../components/footer";
import Nav from "../components/nav";

const MPage = (props) => {
  const { logo, nombre, nombreUrl } = props.municipio;
  return (
    <Fragment>
      <Nav logo={logo} nombre={nombre} nombreUrl={nombreUrl} />
      <div className="container main-container">
        <div className="row">
          <div className="col-md-12">{props.children}</div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default MPage;
